import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from "react";
import SelectWithSearch from "@/features/shared/components/SelectWithSearch/SelectWithSearch";
import useParentTasks from "@/features/task/hooks/useParentTasks";
const ParentTaskSelector = ({ onSelect, initialValue, currentTaskId }) => {
    const { tasks } = useParentTasks();
    const [selected, setSelected] = useState(null);
    useEffect(() => {
        if (initialValue?.id) {
            setSelected({ value: initialValue.id, label: initialValue.title ?? "" });
        }
        else {
            setSelected(null);
        }
    }, [initialValue]);
    const options = useMemo(() => {
        const filteredTasks = tasks.filter((t) => t.id !== currentTaskId);
        const taskOptions = filteredTasks.map((t) => ({ value: t.id ?? null, label: t.title ?? "" }));
        return [{ value: null, label: "Aucun" }, ...taskOptions];
    }, [tasks, currentTaskId]);
    const handleSelect = (option) => {
        if (option.value === null) {
            setSelected(null);
            onSelect(undefined);
            return;
        }
        const found = tasks.find((t) => t.id === option.value);
        if (found) {
            setSelected({ value: found.id ?? null, label: found.title ?? "" });
            onSelect(found);
        }
        else {
            setSelected(null);
            onSelect(undefined);
        }
    };
    return (_jsx(SelectWithSearch, { label: "\u00C9pic", options: options, selectedItem: selected, onSelect: handleSelect }));
};
export default ParentTaskSelector;
